import React from "react";
import Image from "gatsby-image";
import { useTeamPhotos } from "shared/Hooks/About/Team";
import { FizosteoImages } from "./FizosteoImage";
import Opengraph from "../../../../assets/images/cases/fizosteo/fizosteo-opengraph.png"
// icons todo
import VueIcon from "assets/images/technologies/vue.svg";

export const FizosteoData = () => {
  const images = FizosteoImages();
  const team_images = useTeamPhotos();
  return {
    color: "#fff",
    title: "Fiz-osteo",
    seo:
      "Prowadzimy zabiegi z zakresu osteopatii i fizjoterapii pediatrycznej. Naszą ofertę kierujemy zarówno do młodszych i starszych dzieci, jak i dorosłych.",
    opengraph: Opengraph,
    slug: "fizosteo",
    hero: {
      title: "Nowe spojrzenie na fizjoterapię dziecięcą",
      color: "",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Działania odpowiadające na potrzeby marki",
      technologies: ["Strona WWW", "UX Workshops" ,"Rebranding", "Social Media"],
      text:
        "Marka, która na co dzień pomaga innym, tym razem potrzebowała  pomocy agencji interaktywnej! Dla Fiz-Osteo wykonaliśmy nową stronę internetową. Z naszą pomocą marka także przeszła rebranding, którego efektem było nowe logo. Ponadto zajęliśmy się social media marketingiem - prowadziliśmy profile społecznościowe na Facebooku i Instagramie. Zaprojektowaliśmy grafiki i szablony, które wykorzystywaliśmy w tworzeniu kreatywnego i wartościowego contentu w internecie.",
      list: [
        "Przeprowadziliśmy rebranding marki",
        "Zaprojektowaliśmy nowe logo",
        "Wykonaliśmy grafiki i szablony",
        "Zaprojektowaliśmy i zakodowaliśmy stronę internetową",
        "Opracowaliśmy schemat działań social media",
      ],
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.fizosteo_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.fizosteo_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.fizosteo_3.childImageSharp.fluid}
        />
      ),
      fourth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.fizosteo_4.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.fizosteo_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.fizosteo_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.fizosteo_3f.childImageSharp.fluid}
          />
        ),
      },
      fourth: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.fizosteo_4f.childImageSharp.fluid}
          />
        ),
      },
      fifth: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.fizosteo_5f.childImageSharp.fluid}
          />
        ),
      },
      sixth: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.fizosteo_6f.childImageSharp.fluid}
          />
        ),
      },
    },
    headers: {
      first: "Funkcjonalna i wydajna strona WWW",
    },

    text_boxes: {
      first: {
        title: "Nowe logo - nowy wizerunek marki",
        text:
          "Zmiany są nieodłącznym elementem życia - również w przypadku prowadzenia własnego biznesu. Dlatego jednym z zaproponowanych przez nas działań był rebranding. Zaprojektowaliśmy nowe logo, które odzwierciedla wartości, którymi kieruje się marka. Jest nowoczesne, pozytywnie wpływa na rozwój firmy, a do tego tworzy atrakcyjny wizerunek całego przedsiębiorstwa.",
      },
      second: {
        title: "Przejrzysty układ strony internetowej",
        text:
          "Zaprojektowaliśmy i wdrożyliśmy stronę WWW, która przedstawia szeroką ofertę Fiz-Osteo i umożliwia kontakt z marką. Jest ona intuicyjna i funkcjonalna, a także zoptymalizowana pod kątem wyszukiwarek internetowych. W projekcie użyliśmy autorskich grafik.",
      },
      third: {
        title: "Nowoczesne technologie w projektowaniu witryn",
        text:
          "Na początku wykonaliśmy makiety UX/UI, które pozwoliły dostosować witrynę do oczekiwań i potrzeb klienta. Wykorzystaliśmy innowacyjne rozwiązania i technologie, które wpłynęły na jej dynamikę i wydajność. Strona WWW jest także w pełni responsywna, przez co przeglądanie treści na urządzeniach mobilnych nie sprawia problemów.",
      },
      fourth: {
        title: "Komunikacja online przyjazna odbiorcom",
        text:
          "Tak jak Fiz-Osteo kompleksowo zajmuje się swoimi pacjentami, tak i my kompleksowo poprowadziliśmy działania marketingowe marki w sieci. Zaprojektowaliśmy grafiki i szablony do publikacji postów w social mediach, a przy współpracy z marką tworzyliśmy także wartościowe i angażujące treści. ",
      },
      fifth: {
        title: "Skuteczne działania marketingowe",
        text:
          "Do naszych zadań należało także prowadzenie kampanii reklamowych. W końcu marka, której misją jest pomaganie innym, powinna być widoczna! Zadbaliśmy o skuteczne reklamy, które wzmocniły nasze działania reklamowe i pozwoliły Fiz-Osteo pozyskać nowych klientów. ",
      },


    },
    technologies: {
      title: "Przykładowy dłuższy nagłówek dotyczący technologii",
      text: (
        <>
          Współpracę z agencją InteractiveVision wysoko cenimy za zaangażowanie,
          elastyczność oraz kompleksowość usług. Zawsze mogliśmy liczyć na
          profesjonalne doradztwo w zakresie planowanych działań oraz
          kreatywność.
          <br />
          <br />
          Dotychczasowa współpraca z tą firmą pozwala nam na rekomendowanie jej
          usług innym.
        </>
      ),
      icons: [
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
      ],
    },
    marketing: {
      counts: [
        {
          count: "20%",
          title: "Zwiększona konwersja",
        },
        {
          count: 2000,
          title: "Polubień w 1 miesiąc",
        },
        {
          count: "53%",
          title: "zwiększona sprzedaż",
        },
      ],
      team: [
        {
          name: "Patrycja Bilska",
          position: "Project Manager",
          image: (
            <Image alt="" fluid={team_images.Patrycja.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Skórka",
          position: "Frontend Developer",
          image: (
            <Image alt="" fluid={team_images.Rafal.childImageSharp.fluid} />
          ),
        },
        {
          name: "Patryk Białas",
          position: "Graphic designer",
          image: (
            <Image alt="" fluid={team_images.Patryk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Krawiec",
          position: "Backend Developer",
          image: (
            <Image alt="" fluid={team_images.Krawczyk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Żmuda",
          position: "Marketing Specialist",
          image: (
            <Image alt="" fluid={team_images.Kuba.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Furman",
          position: "Sales Manager",
          image: (
            <Image alt="" fluid={team_images.Furman.childImageSharp.fluid} />
          ),
        },
      ],
    },
  };
};
